"use client";

import * as AvatarPrimitive from "@radix-ui/react-avatar";
import * as React from "react";

import { cn } from "~/lib/utils";

function Avatar({ ref: reference, className, ...props }: { ref?: React.Ref<React.ElementRef<typeof AvatarPrimitive.Root>> } & React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>) {
	return (
		<AvatarPrimitive.Root
			className={cn(
				"relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
				className
			)}
			ref={reference}
			{...props}
		/>
	);
}
Avatar.displayName = AvatarPrimitive.Root.displayName;

function AvatarImage({ ref: reference, className, ...props }: { ref?: React.Ref<React.ElementRef<typeof AvatarPrimitive.Image>> } & React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>) {
	return (
		<AvatarPrimitive.Image
			className={cn("aspect-square h-full w-full", className)}
			ref={reference}
			{...props}
		/>
	);
}
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

function AvatarFallback({ ref: reference, className, ...props }: { ref?: React.Ref<React.ElementRef<typeof AvatarPrimitive.Fallback>> } & React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>) {
	return (
		<AvatarPrimitive.Fallback
			className={cn(
				"flex h-full w-full items-center justify-center rounded-full bg-muted absolute inset-0",
				className
			)}
			ref={reference}
			{...props}
		/>
	);
}
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export { Avatar, AvatarFallback, AvatarImage };
